<template>
  <div>
    <div
      class="modal modal-right fade"
      ref="modal_form_order"
      id="modal_add_sale_contact"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="order_form_modal"
    >
      <div
        class="modal-dialog modal-lg"
        role="document"
      >
        <div
          class="modal-content"
          ref="section"
        >
          <form
            id="addSaleContact"
            ref="form"
            @submit.prevent="submitForm()"
            method="post"
          >
            <div class="modal-header bg-dark">
              <h6 class="modal-title">
                <span v-if="$parent.submitAction == 'update-sale-contact'">{{
                  $parent.integration.name
                }}</span>
                <span v-else>{{ $t("Add Sale Contact") }}</span>
              </h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div 
              v-if="loading" 
              class="p-3"
            >
              <placeholder-content is-load="true" />
            </div>
            <div v-if="hasFeature && !loading">
              <SubscriptionExpired />
            </div>
            <div v-if="!loading && !hasFeature">
              <div class="px-0">
                <legend class="font-size-lg px-3 py-2">
                  <i class="fas fa-info-circle mr-2" />{{
                    $t("Sale Contact Information")
                  }}
                </legend>
              </div>
              <div class="col-lg-12">
                <Channel />
              </div>
              <div class="col-md-12">
                <div class="form-group mr-3">
                  <label class="ml-2">{{ $t("Sale Contact Name") }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    class="form-control ml-2"
                    :class="
                      $parent.unavailable_name || $parent.validate_name
                        ? 'border-danger'
                        : ''
                    "
                    :placeholder="$t('Enter sale contact name...')"
                    v-model="$parent.integration.name"
                  >
                  <label
                    class="validation-invalid-label ml-2"
                    for="unavailableInfo_name"
                    v-if="$parent.unavailable_name"
                  >{{ $t("This sales contact name is already in use.") }}</label>
                  <label
                    class="validation-invalid-label ml-2"
                    for="variationInfo_name"
                    v-if="$parent.validate_name"
                  >{{ $t("Please enter sale contact name") }}</label>
                </div>
                <div class="row col-md-12">
                  <div class="ml-2">
                    <p>{{ $t("Status") }}</p>
                  </div>
                  <div class="col-1">
                    <span class="ml-2">
                      <toggle-button
                        :class="$parent.isStandard == 1 ? 'point-none disable-click' : ''"
                        name="is_active"
                        id="is_active"
                        :width="38"
                        color="#64BD63"
                        :speed="200"
                        :margin="1"
                        v-model="$parent.integration.is_active"
                        sync
                      />
                    </span>
                  </div>
                </div>
                <div>
                  <i
                    class="fa-solid fa-circle-info ml-2 mr-1"
                    style="color: #b0b0b0"
                  />
                  <label style="color: #b0b0b0">
                    {{ $t("If disable channel your order will not sync anyway") }}
                  </label>
                </div>
              </div>
              <div class="px-0">
                <legend class="font-size-lg px-3 py-2">
                  <i class="fa-solid fa-store mr-1 mt-3" />{{ $t("Account") }}
                </legend>
              </div>
              <div class="col-md-12">
                <div class="form-group mr-3">
                  <label class="ml-2">
                    {{ displayLinkType }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="url"
                    class="form-control ml-2"
                    :placeholder="$t(displayPlaceholder) + '...'"
                    v-model="$parent.integration.url"
                  >
                  <label
                    class="validation-invalid-label ml-2"
                    for="variationInfo_url"
                    v-if="$parent.validate_url"
                  >
                    {{ $t("Please enter") + " " + $t(displayPlaceholder) }}
                  </label>
                  <i
                    class="fa-solid fa-circle-info ml-2 mr-1 mt-2"
                    style="color: #b0b0b0"
                  />
                  <label class="text-lowercase" style="color: #b0b0b0">
                    {{ $t("Example") + " " + displayExampleUrl }}
                  </label>
                </div>
              </div>
              <div
                class="
                  modal-footer
                  fixed-bottom
                  bg-light
                  border-bottom
                  justify-content-center
                  py-2
                "
              >
                <button
                  type="submit"
                  class="btn bg-primary ml-2"
                  :class="[loading ? 'disabled ' : '']"
                  :disabled="loading"
                >
                  <i
                    :class="[loading ? 'icon-spinner2 spinner' : 'fas fa-save', 'mr-2']"
                  />{{ $t("Save") }}
                </button>
                <button
                  type="button"
                  class="btn btn-light mx-2"
                  data-dismiss="modal"
                >
                  {{ $t("Cancel") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Channel from "./Channel";
import { ToggleButton } from "vue-js-toggle-button";

import { createSaleContact, updateSaleContact } from "./api/axios.js";
import Api from "@/services/endpoint/tenant.service.js";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import SubscriptionExpired from "@/components/tenancy/admin/error-page/templates/SubscriptionExpired.vue";

export default {
  components: {
    Channel,
    ToggleButton,
    PlaceholderContent,
    SubscriptionExpired,
  },
  data() {
    return {
      loading: false,
      // channelName : 'Url',
      channelName: {
        Facebook: "Facebook Url",
        Line: "Line ID",
        "Line OA": "Line OA ID",
        Instagram: "Instagram Account",
        Tiktok: "Tiktok Account",
        Youtube: "Youtube Url",
        Call: "Telephone Number",
        Website: "Website Url",
        Other: "Other",
        "TV Shopping": "TV Shopping",
      },
      exampleUrl: {
        Facebook: "https://www.facebook.com/GoshipShop",
        Line: "GoshipShop",
        "Line OA": "@GoshipShop",
        Instagram: "@GoshipShop",
        Tiktok: "@GoshipShop",
        Youtube: "https://www.youtube.com/Goshipshop",
        Call: "088-123-4567",
        Website: "https://www.mywebsite.com",
        Other: "https://www.other.com",
        "TV Shopping": "https://www.tvshoping.com",
      },
      placehold: {
        Facebook: "your facebook url",
        Line: "your line official id",
        "Line OA": "your line OA id",
        Instagram: "your instagram account",
        Tiktok: "your tiktok account",
        Youtube: "your youtube url",
        Call: "your telephone number",
        Website: "your website url",
        Other: "your other url",
        "TV Shopping": "your tv shopping url",
      },
      displayExampleUrl: "",
      displayPlaceholder: "",
      displayLinkType: "",
      hasFeature: false
    };
  },
  methods: {
    submit: function () {
      this.loading = !this.loading;
      this.submitForm();
    },
    submitForm: async function (e) {
      if (this.$parent.hasFeature) {
        this.$parent.validate_name = false;
        this.$parent.unavailable_name = false;
        this.$parent.validate_url = false;
        this.$parent.validate_channel = false;
        this.$parent.validate = true;

        this.loading = true;
        let form = $("#addSaleContact");

        if (
          this.$parent.integration.name == "" ||
          this.$parent.integration.name == null
        ) {
          this.$parent.validate_name = true;
          this.$parent.validate = false;
          this.loading = false;
        }
        if (this.$parent.integration.name && this.checkDupChannelName()) {
          this.$parent.unavailable_name = true;
          this.$parent.validate = false;
          this.loading = false;
        }
        if (this.$parent.integration.url == "" || this.$parent.integration.url == null) {
          this.$parent.validate_url = true;
          this.$parent.validate = false;
          this.loading = false;
        }
        if (
          this.$parent.integration.integration_type_id == 0 ||
          this.$parent.integration.integration_type_id == null
        ) {
          this.$parent.validate_channel = true;
          this.$parent.validate = false;
          this.loading = false;
        }

        if (this.$parent.validate) {
          const response = await this.saveSaleContact(
            form.serialize(),
            this.$parent.integration.id
          );

          let responseMsgSuccess = this.$t("Save Sale Contact Success");
          let responseMsgFailed = this.$t("Save Sale Contact Falid");
          if (this.$parent.submitAction == "update-sale-contact") {
            responseMsgSuccess = this.$t("Update Sale Contact Success");
            responseMsgFailed = this.$t("Update Sale Contact Falid");
          }
          if (response.data.data != undefined) {
            this.$parent.integrations = response.data.data;
            $("#modal_add_sale_contact").modal("hide");
            this.loading = false;
            this.$toastr.s(
              responseMsgSuccess,
              "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
            );
          } else {
            this.$toastr.w(
              responseMsgFailed,
              "<span class='icon-warning22'></span>" + this.$t("Warning")
            );
          }
        }
      } else {
        this.$toastr.Add({
          type: "warning",
          title:
            "<span class='icon-warning22 mr-2'></span>" +
            this.$t("Something went wrong."),
          msg: this.$t(
            "Save information failed. This feature is not included in your store's package."
          ),
          clickClose: true,
          timeout: 5000,
          position: "toast-top-right",
        });
      }
    },

    async saveSaleContact(data, id = "") {
      var response = null;
      switch (this.$parent.submitAction) {
        case "update-sale-contact":
          response = await updateSaleContact(data, id);
          this.$parent.setParams([])
          break;
        case "create-sale-contact":
          response = await createSaleContact(data);
          this.$parent.setParams([])
          break;
      }
      if (response == "not active plan") {
        this.$toastr.Add({
          type: "warning",
          title:
            "<span class='icon-warning22 mr-2'></span>" +
            this.$t("Something went wrong."),
          msg: this.$t(
            "Save information failed. This feature is not included in your store's package."
          ),
          clickClose: true,
          timeout: 5000,
          position: "toast-top-right",
        });
        this.loading = false;
        return;
      } else {
        return response;
      }
    },

    async feedData(integrationTypeName) {
      this.loading = true;
      this.hasFeature = false;
      let hasFeature = await Api.Feature.postHasFeature("feature-sale-contact");
      if (!hasFeature.data.status) {
        this.hasFeature = true;
      }

      this.setParams(integrationTypeName);

      this.loading = false;
    },

    setParams(integrationTypeName) {
      if (this.exampleUrl[integrationTypeName] != undefined) {
        this.displayExampleUrl = this.exampleUrl[integrationTypeName];
      }
      if (this.placehold[integrationTypeName] != undefined) {
        this.displayPlaceholder = this.placehold[integrationTypeName];
      }
      if (this.channelName[integrationTypeName] != undefined) {
        this.displayLinkType = this.channelName[integrationTypeName];
      }
    },

    checkDupChannelName() {
      let findName = this.$parent.integrations.filter((p) =>
        this.$parent.submitAction == "update-sale-contact"
          ? p.id !== this.$parent.integration.id &&
            (p.name.replace(/\s/g, "") ==
              this.$parent.integration.name.replace(/\s/g, "") ||
              p.name == this.$parent.integration.name)
          : p.name.replace(/\s/g, "") ==
              this.$parent.integration.name.replace(/\s/g, "") ||
            p.name == this.$parent.integration.name
      );

      let findChannel = false;
      if(findName.length){
        let checkData = findName.find(item => item.integration_type_id == this.$parent.integration.integration_type_id);
        if(checkData){
          findChannel = true;
        }
      }

      return (findName && findChannel ) ? true : false;
    },
  },
  mounted() {
    this.feedData("Facebook");
  },
};
</script>
<style scoped>
  .disable-click{
    -webkit-filter: grayscale(1) brightness(100%) contrast(100%) invert(0.15);
    filter: grayscale(1) brightness(100%) contrast(100%) invert(0.15);
    opacity: 0.3;
  }
 </style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/ModalAddSaleContact.vue